import { useNotConnectedFeedback } from '@/src/general/hooks/useNotConnectedFeedback'

import { Button, type TDefaultButtonProps } from '../default'

export const ConnectedButton = ({ ref, onPress, ...otherProps }: TDefaultButtonProps) => {
  const { isOffline, showNotConnectedToast } = useNotConnectedFeedback()

  return (
    <Button ref={ref} isInactive={isOffline} onPress={!isOffline ? onPress : showNotConnectedToast} {...otherProps} />
  )
}

ConnectedButton.displayName = 'ConnectedButton'
